<template>
  <div>
    <v-card
      elevation="1"
      class="card card-mobile"
      flat
      style="margin-left: 3rem; margin-right: 1rem; border-radius: 15px"
    >
      <Breadcrumbs :items="breadcrumbs" page_title="knowledgesharing" />

      <v-layout row align-center class="ml-7 mt-10">
        <v-flex xs8 sm6 md6 lg4 xl2>
          <title-block
            :relative="$vuetify.breakpoint.name !== 'xs' ? true : false"
            width="250"
            height="60"
            >{{ "Knowledge Sharing" }}</title-block
          >
        </v-flex>
      </v-layout>

      <v-container>
        <v-row justify="space-between" class="ma-1">
          <v-col cols="12" xs="12" sm="3" lg="3" md="3">
            <v-text-field
              outlined
              dense
              clearable
              style="border-radius: 8px"
              prepend-inner-icon="mdi-magnify"
              :placeholder="$t('search')"
              v-model="search"
            >
            </v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col xs="12" sm="2" class="d-flex justify-end">
            <v-btn
              dark
              class="add_btn text-capitalize white--text"
              color="#A6CC39"
              style="border-radius: 8px !important;"
              @click="checkKnowledgeSharingAdd()"
            >
              <v-icon style="color: #ffffff" class="mr-1" :small="true"
                >mdi-plus-box-outline</v-icon
              >
              <span style="font-size: 14px; color: #ffffff">{{
                $t("addnew")
              }}</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row no-gutters class="px-0">
          <v-col>
            <v-data-table
              :loading="loading"
              loading-text="Loading... Please wait"
              :headers="headers"
              :items="items"
              :search="search"
              @page-count="pageCount = $event"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              class="exprt-table"
              hide-default-footer
            >
              <template v-slot:item.sort="{ item }">
                <div class="d-flex">
                  <v-menu open-on-hover offset-y min-width="55px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        width="55"
                        height="30"
                        color="#47484b"
                        class="text-capitalize mt-1 sort_Btn"
                        outlined
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ item.sort }}
                        <v-icon style="margin-left: 0px; margin-right: -0.6rem"
                          >mdi-chevron-down</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list
                      :style="
                        items.length == 1
                          ? { height: '69px' }
                          : items.length == 2
                          ? { height: '103px' }
                          : items.length == 3
                          ? { height: '136px' }
                          : items.length == 4
                          ? { height: '170px' }
                          : { height: '205px' }
                      "
                      class="overflow-y-auto"
                    >
                      <v-list-item
                        v-for="(temp, index) in sortNumberItems"
                        :key="index"
                        @click="
                          (item.sort = temp.value), changeSubmitSortNo(item)
                        "
                      >
                        <v-list-item-title>{{ temp.value }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  v-if="$vuetify.breakpoint.smAndUp"
                  color="#4FB14E"
                  text
                  style="font-size: 15px"
                  class="text-capitalize"
                  @click="checkLessonLearnEdit(item)"
                >
                  <v-icon>mdi-square-edit-outline</v-icon
                  >{{ $t("edit") }}</v-btn
                >
                <v-btn
                  v-if="$vuetify.breakpoint.smAndUp"
                  color="#FF6060"
                  style="font-size: 15px"
                  text
                  class="text-capitalize"
                  @click="checkLessonLearnDelete(item)"
                >
                  <v-icon>mdi-delete-outline</v-icon>{{ $t("delete") }}</v-btn
                >
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row no-gutters class="pt-3">
          <v-col cols="12" xs="12" sm="9">
            <div class="d-flex text-left">
              <v-pagination
                circle
                v-model="page"
                class="pagination"
                :length="pageCount"
              ></v-pagination>
            </div>
          </v-col>
          <v-col cols="12" xs="12" sm="3" class="d-flex justify-end">
            <p class="mt-3 pr-4">{{ $t("show") }}</p>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  width="70"
                  v-bind="attrs"
                  v-on="on"
                  style="border: 1px solid #c0c0c0; opacity: 1"
                  class="text-capitalize mt-1 mr-1"
                  outlined
                >
                  {{ itemsPerPage }}
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in paginationCount"
                  :key="index"
                  @click="itemsPerPage = item.title"
                >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <!-- Success -->
    <v-dialog v-model="successDialog" width="587">
      <v-card>
        <v-card-title
          style="font-size: 30px"
          class="secondary white--text justify-center"
          >{{ message }}</v-card-title
        >

        <v-card-text>
          <p
            style="
              font-size: 16px;
              color: #4d4f5c;
              opacity: 1;
              text-align: center;
            "
            class="mt-3"
          >
            Deleting Knowledge Sharing is successful.
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            class="text-capitalize mx-auto"
            width="100"
            color="#6CC8A0"
            @click="successDialog = false"
            >{{ $t("ok") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Delete -->
    <v-dialog v-model="deleteknowledgesharingdialog" width="500">
      <v-card>
        <v-card-title style="font-size: 30px; height: 70px">
          <p>{{ $t("deleteconfirm") }}</p>
        </v-card-title>

        <v-card-text>
          <p
            class="mt-5"
            style="font-size: 20px; color: #4d4f5c; text-align: center"
          >
            {{ $t("suredelete") }}
            <br />
            "Knowledge Sharing {{ editData.caseDescription }} " ?
          </p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="text-capitalize"
            style="font-size: 20px"
            width="100"
            text
            outlined
            @click="deleteknowledgesharingdialog = false"
            >{{ $t("cancel") }}</v-btn
          >
          <v-btn
            class="text-capitalize"
            width="100"
            style="font-size: 20px"
            color="error"
            @click="deleteData()"
            >{{ $t("delete") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Add Dialog-->

    <!--Edit Dialog-->

    <Edit
      :show="editDialog"
      :editItem="editData"
      @close="editDialog = false"
      :fullName="fullName_"
      @confirm="handelEdit"
    />
    <Add
      :show="addDialog"
      @close="addDialog = false"
      :fullName="fullName_"
      @confirm="handleConfirm"
    />

    <!-- <SuccessDialog
      :show="successDialog1"
      :title="$t('success')"
      :text="message"
      @close="(successDialog1 = false), getData()"
    /> -->
  </div>
</template>
<script>
import Add from "./Add.vue";
import Edit from "./Edit.vue";
import axios from "axios";
import enurl from "@/api/environment";
import { mapGetters } from "vuex";
import * as moment from "moment/moment";
import TitleBlock from "@/components/global_component/TitleBlock";

export default {
  components: {
    Add,
    Edit,
    TitleBlock
  },
  data: () => ({
    editLessonLearn: {},
    lessonlearn: {
      caseTitle: "",
      caseDescription: "",
      wordContent: "",
      caseImage: "",
      link: "",
      companyId: localStorage.getItem("companyID"),
      startDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      file: null,
      fileName: "",
      fileUrl: "",
      pdffilename: "",
      PDFUrl: "",
      PDFButtonDisable: false
    },
    editDialog: false,
    editData: {},
    deleteknowledgesharingdialog: false,
    successDialog: false,
    successDialog1: false,
    fullName_: "",
    addDialog: false,
    loading: true,
    message: "",
    url: enurl.apiUrl,
    search: null,
    items: [],
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    paginationCount: [{ title: 10 }, { title: 20 }, { title: 30 }],
    breadcrumbs: [
      {
        sidebar_title: "defaultcontent"
      },
      {
        text: "knowledgesharing"
      }
    ]
  }),
  computed: {
    ...mapGetters([
      "editLessonLearnData",
      "showFirstTimeEditDataForLessonLearn"
    ]),
    // formattedItems() {
    //   return this.items.map(item => ({
    //     ...item,
    //     createDate: this.formatDate(item.createDate),
    //     endContentDate: this.formatDate(item.endContentDate),
    //     startContentDate: this.formatDate(item.startContentDate),
    //   }));
    // },
    headers() {
      return [
        {
          text: "#",
          value: "no",
          align: "left",
          class: "tableColor",
          sortable: false,
          width: "20px"
        },
        {
          text: this.$t("title"),
          align: "left",
          value: "caseTitle",
          class: "tableColor",
          width: "250px"
        },
        {
          text: this.$t("description"),
          align: "left",
          value: "caseDescription",
          class: "tableColor",
          width: "250px"
        },
        {
          text: this.$t("startdates"),
          align: "left",
          value: "startContentDate1",
          width: "160px"
        },
        {
          text: this.$t("enddate"),
          align: "left",
          value: "endContentDate1",
          width: "160px"
        },
        {
          text: this.$t("createdateM"),
          align: "left",
          value: "startContentDate1",
          width: "170px"
        },
        // {
        //   text: this.$t("createdby"),
        //   align: "left",
        //   value: "createBy",
        //   width: "160px"
        // },
        {
          text: this.$t("sort"),
          align: "left",
          value: "sort",
          width: "110px"
        },
        {
          text: this.$t("action"),
          align: "center",
          value: "actions",
          class: "tableColor",
          width: "220px"
        }
      ];
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    checkLessonLearnEdit(item) {
      let self = this;
      console.log("hello");
      console.log("item", item);

      this.$store.commit("saveEditLessonLearn", {
        ...item
      });
      this.$store.commit("showFirstTimeEditDataForLessonLearn");
      this.editDialog = true;
      self.editDialog = true;
    },
    //     checkLessonLearnEdit(item) {
    //   console.log("API item:", item); // Check what the item actually contains
    //   this.editLessonlearn(item);
    // },
    //    editLessonlearn(item) {
    //     console.log("hello item",item);
    //    // this.$store.commit("saveEditLessonLearn", {
    //   //    ...item,
    //  //  });

    //  //    this.$store.commit("showFirstTimeEditDataForLessonLearn");
    //  this.$store.commit("lessonlearn/saveEditLessonLearn", { ...item });
    // this.$store.commit("lessonlearn/showFirstTimeEditDataForLessonLearn");

    //      this.editDialog = true;
    //    },
    //   editLessonlearn(item) {
    //   console.log("hello item", item); // Verify the structure of item

    //   // Directly access caseTitle since it's a top-level property
    //   const caseTitle = item.caseTitle || null;
    //   console.log("Case Title:", caseTitle);

    //   this.$store.commit("lessonlearn/saveEditLessonLearn", { ...item });
    //   this.$store.commit("lessonlearn/showFirstTimeEditDataForLessonLearn");

    //   this.editDialog = true;
    // },
    async checkLessonLearnDelete(item) {
      let self = this;
      self.deleteknowledgesharingdialog = true;
      self.editData = item;
    },

    async deleteData() {
      let self = this;
      const id = self.editData.id; // ID to delete

      try {
        const res = await axios.delete(
          `${self.url}CaseStudies/DeleteCaseStudy`,
          {
            params: { id: id } // Send ID as query parameter
          }
        );
        self.message = res.data.message;
        self.successDialog = true;
        self.deleteknowledgesharingdialog = false;
        self.getData(); // Refresh the data after deletion
      } catch (err) {
        alert("Error deleting case study: " + err);
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = String(date.getFullYear()).slice(0);
      return `${day}/${month}/${year}`;
    },
    handelEdit() {
      this.editDialog = false;
      this.successDialog1 = true;
      this.getData();
      // this.message = this.$t('editlessonlearn');
    },
    handleConfirm() {
      this.addDialog = false; // Close the Add dialog
      this.successDialog1 = true;
      this.getData();
      this.message = this.$t("addKnowledgeSharings"); // Use translation for the message
    },
    async checkKnowledgeSharingAdd() {
      let self = this;
      self.addDialog = true;
    },
    async getData() {
      console.log("hello");
      let self = this;
      const companyID = "00000000-0000-0000-0000-000000000000";
      //const data = {
      //    companyID: '00000000-0000-0000-0000-000000000000',
      //  };

      //  let policy = localStorage.getItem("policyType");
      //  if (policy == "false") {
      //     self.Dialog = true;
      //    }

      self.loading = true;
      await axios
        .get(`${self.url}CaseStudies/GetCaseStudies?Id=` + companyID)
        .then(function(res) {
          console.log("res.data.data", res.data.data);
          self.items = res.data.data.map((v, i) => ({
            ...v,
            no: i + 1,
            startContentDate1: moment(res.data.data[i].startContentDate)
              .local()
              .format("DD/MM/YYYY"),
            endContentDate1: moment(res.data.data[i].endContentDate)
              .local()
              .format("DD/MM/YYYY")
          }));
          self.item_no = self.items.length;
          let temp_null = [{ value: "" }];
          let temp_num = self.items.map((v, i) => {
            return { value: i + 1 };
          });
          self.sortNumberItems = temp_null.concat(temp_num);
        });
      self.loading = false;
    }
  }
};
</script>
<style scoped>
::v-deep .v-text-field__details {
  display: none !important;
}
::v-deep .exprt-table {
  margin-left: 16px;
  margin-right: 16px;
}
::v-deep .exprt-table thead th:first-child {
  border-radius: 8px 0 0 8px !important;
}
::v-deep .exprt-table thead th:last-child {
  border-radius: 0 8px 8px 0 !important;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  font-size: 17px !important;
  color: #47484b !important;
  background-color: #e0e0e0 !important;
  opacity: 1;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  font-size: 16px !important;
  color: #47484b !important;
  opacity: 1;
  vertical-align: center;
  height: 65px;
}
::v-deep .primary {
  color: #000000 !important;
  background-color: #a6cc39 !important;
  opacity: 1;
}
::v-deep .v-label {
  font-size: 20px !important;
}
::v-deep .v-dialog {
  border-radius: 16px !important;
}
::v-deep .pagination .primary {
  background-color: #a6cc39 !important;
  color: #ffffff !important;
}

/* For Sort menu. */
::v-deep .sort_Btn.v-btn:not(.v-btn--round).v-size--default {
  min-width: 50px;
  font-size: 16px;
  border: 1px solid #c0c0c0;
  opacity: 1 !important;
  padding: 0 0;
  border-radius: 8px;
}
::v-deep .v-list.overflow-y-auto.v-sheet.theme--light::-webkit-scrollbar {
  width: 7px !important;
}
/* Track */
::v-deep .v-list.overflow-y-auto.v-sheet.theme--light::-webkit-scrollbar-track {
  width: 6px !important;
  background: #e6e6e6;
  border-left: 1px solid #dadada;
}
/* Handle */
::v-deep .v-list.overflow-y-auto.v-sheet.theme--light::-webkit-scrollbar-thumb {
  background: #b0b0b0;
  border: solid 2px #e6e6e6;
  border-radius: 7px;
}
::v-deep .v-list.overflow-y-auto.v-sheet.theme--light {
  padding-top: 0 !important;
  padding-left: 0 !important;
  padding-bottom: 0 !important;
}
::v-deep .v-list-item {
  min-height: 32px;
  border-top: 2px solid #707070;
}
::v-deep .v-list-item:hover {
  background-color: #707070 !important;
}
::v-deep
  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover {
  color: #ffffff !important;
}
/* end sort menu. */
@media (min-width: 1264px) {
  .container {
    max-width: unset !important;
    margin-top: 1.5rem !important;
  }
}
::v-deep .accent {
  background-color: #a6cc39 !important;
}
::v-deep .accent--text {
  color: #a6cc39 !important;
}
::v-deep .primary--text {
  color: #a6cc39 !important;
  border-color: #a6cc39 !important;
}
</style>

<style>
.v-pagination__navigation {
  border-radius: 6px !important;
  box-shadow: none !important;
  border: 1px solid #c0c0c0;
}
.v-pagination__item {
  background: transparent !important;
  box-shadow: none !important;
}
</style>
